
import { Options, Vue } from 'vue-class-component';
import AppTile from './AppTile.vue';
import { Prop } from 'vue-property-decorator';
import api from '@/shared/api';

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item: any) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param sources
 */
function mergeDeep(target: any, ...sources: any): any {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

@Options({
    components: {
        AppTile,
    },
})
export default class AssetPickerComponentSettings extends Vue {
    @Prop()
    protected app: undefined | any = undefined;

    protected ready = false;

    protected type = '';

    async created() {
        this.type = this.app.settings && this.app.settings.type ? this.app.settings.type : '';

        this.ready = true;
    }

    public getSettings() {
        return mergeDeep(this.app.settings ?? {}, { type: this.type });
    }
}
